import { Component } from '@angular/core';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent {
  isExpanded = false;

  menuItems = [
    { link: '/pages/dashboard', icon: 'dashboard', label: 'app.dashboard' },
    { link: '/pages/house-monitoring-panel', icon: 'devices', label: 'app.house-monitoring-panel' },
    { link: '/pages/analytics', icon: 'bar_chart', label: 'app.analytics' },
    { link: '/pages/gamification', icon: 'videogame_asset', label: 'app.gamification' },
    { link: '/pages/notifications', icon: 'notifications', label: 'app.alerts' },
    { link: '/pages/preferences', icon: 'settings', label: 'app.preferences' },
    { link: '/pages/about', icon: 'info', label: 'app.about-us' },
    { link: '/pages/my-account', icon: 'perm_identity', label: 'app.my-account' }
  ];
}
